import { createContext } from "react";

// Currently, this value is used for logo (cupixworks, cupixvista)
export const CupixThemeContext = createContext('cupix');